import type { ReactNode } from 'react';
import Breadcrumbs, { type Crumb } from '@/components/feature/Breadcrumbs';

type PageHeaderProps = {
  eyebrow: string;
  title: ReactNode;
  description: string;
  crumbs: Crumb[];
  meta?: { label: string; value: string }[];
};

export default function PageHeader({ eyebrow, title, description, crumbs, meta }: PageHeaderProps) {
  return (
    <section className="relative bg-foreground-950 pt-28 md:pt-36 pb-12 md:pb-16 overflow-hidden">
      <div
        className="absolute inset-0 opacity-30 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Abstract%20dark%20editorial%20texture%20with%20soft%20crimson%20and%20amber%20light%20sweeps%20on%20deep%20charcoal%20surface%2C%20subtle%20paper%20grain%2C%20minimal%2C%20no%20text&width=1600&height=600&seq=baoliao-pagehead-01&orientation=landscape)',
        }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/85 to-foreground-950/40" aria-hidden="true" />
      <div className="relative w-full px-4 md:px-8">
        <Breadcrumbs items={crumbs} />
        <span className="mt-6 inline-flex items-center gap-2 text-xs font-label font-medium tracking-[0.2em] uppercase text-accent-300">
          <i className="ri-bookmark-3-line" aria-hidden="true" />
          {eyebrow}
        </span>
        <h1 className="mt-3 text-3xl md:text-5xl font-bold text-background-50 leading-tight max-w-3xl">{title}</h1>
        <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200/85 max-w-2xl">{description}</p>
        {meta && (
          <div className="mt-8 flex flex-wrap gap-6 md:gap-10">
            {meta.map((m) => (
              <div key={m.label} className="flex flex-col gap-1">
                <span className="font-heading text-2xl md:text-3xl font-bold text-background-50">{m.value}</span>
                <span className="text-xs font-label text-background-200/70">{m.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}